import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectProductionTab } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { useStyles } from "./styles";

const ProductionTab = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const data = useSelector(selectProductionTab);

  if (!data) {
    return null;
  }

  return (
    <Box className={styles.content}>
      <Box className={styles.section}>
        <Typography className={styles.sectionTitle}>
          {t("VECHILE_STATUS.PRODUCTION.STATUS")}
        </Typography>
        <Box className={styles.statusRow}>
          <Box className={styles.field}>
            <Typography className={styles.label}>
              {t("VECHILE_STATUS.DETAIL.MAIN_STATUS")}
            </Typography>
            <Box className={styles.readonlyField}>
              <span className={styles.statusPill}>
                {t(data.status.mainStatusValueKey)}
              </span>
            </Box>
            <Typography className={styles.helperText}>
              {t(data.status.mainStatusHelperKey)}
            </Typography>
          </Box>

          <Box className={styles.field}>
            <Typography className={styles.label}>
              {t("VECHILE_STATUS.DETAIL.SUB_STATUS")}
            </Typography>
            <Select
              className={styles.select}
              value={data.status.subStatusValue}
              onChange={(event) =>
                dispatch(actions.updateProductionSubStatus(event.target.value))
              }
              IconComponent={KeyboardArrowDownIcon}
              MenuProps={{
                PaperProps: { className: styles.selectMenuPaper },
              }}
              fullWidth
            >
              {data.status.subStatusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {t(option.valueKey)}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      </Box>

      <Box className={styles.divider} />

      <Box className={styles.itemsRow}>
        {data.items.map((item) => (
          <Box key={item.id} className={styles.itemColumn}>
            <Typography className={styles.itemTitle}>
              {t(item.titleKey)}
            </Typography>
            <Box className={styles.field}>
              <Typography className={styles.label}>
                {t("VECHILE_STATUS.PRODUCTION.STATE")}
              </Typography>
              <Select
                className={styles.select}
                value={item.value}
                onChange={(event) =>
                  dispatch(
                    actions.updateProductionItemValue({
                      id: item.id,
                      value: event.target.value,
                    })
                  )
                }
                IconComponent={KeyboardArrowDownIcon}
                MenuProps={{
                  PaperProps: { className: styles.selectMenuPaper },
                }}
                fullWidth
              >
                {item.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {t(option.valueKey)}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
        ))}
      </Box>

      <Button variant="contained" className={styles.saveButton}>
        {t("VECHILE_STATUS.PRODUCTION.SAVE")}
      </Button>
    </Box>
  );
};

export default ProductionTab;
